import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import { ref, watch } from '@vue/composition-api'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { formatDateTimeDDMMYYHHMM } from '@core/utils/utils'

export default function usePegaPlantoesSyncLogs() {
  const perPage = ref(50)
  const totalItems = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100, 200]
  const searchQuery = ref('')
  const isSortDirDesc = ref(true)
  const sortBy = ref('created_at')
  const institutionId = ref(null)
  const institutionsOptions = ref([])
  const refSyncErrorsTable = ref(null)
  const toast = useToast()
  const beginDate = ref('')
  const endDate = ref('')

  const tableColumns = [
    { key: 'created_at', label: 'Data', formatter: formatDateTimeDDMMYYHHMM },
    { key: 'institution', label: 'Instituição' },
    { key: 'workplace', label: 'Unidade' },
    { key: 'status', label: 'Status' },
    { key: 'error_message', label: 'Mensagem' },
    { key: 'actions', label: 'Ações' },
  ]

  const refetchData = () => {
    refSyncErrorsTable.value.refresh()
  }

  watch([currentPage, institutionId, perPage, searchQuery, beginDate, endDate], () => {
    refetchData()
  })

  const fetchEntries = (ctx, callback) => {
    store
      .dispatch('app-report-pega-plantoes-sync-logs/syncLogs', {
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDirection: isSortDirDesc.value ? 'desc' : 'asc',
        institution: institutionId.value ? institutionId.value.value : '',
        start_date: beginDate.value || null,
        end_date: endDate.value || null,
      })
      .then(response => {
        const { data, meta } = response.data
        callback(data)
        totalItems.value = meta.pagination.total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Erro ao buscar',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  function getStatusTitle(status) {
    if (status === 'failed') return 'Falhou'
    if (status === 'ignored') return 'Ignorado'
    if (status === 'imported') return 'Importado'
    return status
  }
  function getStatusVariant(status) {
    if (status === 'failed') return 'light-danger'
    if (status === 'ignored') return 'light-warning'

    return 'light-success'
  }

  const fetchInstitutions = () => {
    store.dispatch('app-report-pega-plantoes-sync-logs/fetchInstitutions', { })
      .then(response => {
        institutionsOptions.value = response.data.data.map(w => ({
          value: w.id,
          label: w.name,
        }))
      })
  }

  return {
    fetchInstitutions,
    institutionsOptions,
    getStatusTitle,
    getStatusVariant,
    fetchEntries,
    refSyncErrorsTable,
    tableColumns,
    refetchData,
    perPageOptions,
    perPage,
    currentPage,
    totalItems,
    institutionId,
    beginDate,
    endDate,
  }
}
